import { Box } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'

import FormWrapper from 'modules/contracts/components/FlowPage/FormWrapper'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import { translate } from 'modules/contracts/lib/translate'

interface Props {
  form: Form
  translations: { [key: string]: string }
}

const ForfaitJourLegalAndExtras = ({ form, translations }: Props) => {
  const { frenchContractData } = useLegalEntityContractData()

  return (
    <FormWrapper>
      <Box gap="s24">
        <Select
          field={form.get('fr_forfait_jours')}
          label={translate(translations, 'forfait_jours')}
          options={frenchContractData.forfaitJours}
          none={i18n.t('common.none')}
        />
        <Text
          field={form.get('fr_jours_par_an_cents')}
          onChange={(field) => {
            //TODO: Remove this hack once fr_jours_par_an is removed
            form.get('fr_jours_par_an').set(Math.trunc(field.value))
          }}
          type="number"
          label={translate(translations, 'jours_par_an')}
          readonly={!form.data().fr_forfait_jours}
        />
      </Box>
    </FormWrapper>
  )
}

export default observer(ForfaitJourLegalAndExtras)
